import { getFieldArrayError } from '@/src/utils/formUtils';
import { InputText, InputTextProps } from 'primereact/inputtext';
import React from 'react';
import {
  Controller,
  FieldError,
  FieldErrorsImpl,
  useFormContext,
} from 'react-hook-form';
import FormErrorMessage from '../../messages/FormErrorMessage';
import { InputTextarea, InputTextareaProps } from 'primereact/inputtextarea';

type FormControlledInputAreaProps = InputTextareaProps & {
  defaultValue?: string | number;
  formID: string;
  rules?: object;
  disabled?: boolean;
  placeholder?: string; 
  hideErrors?: boolean;
  isFieldArray?: boolean;
};

const FormControlledInputArea = ({
  defaultValue,
  formID,
  rules,
  disabled,
  placeholder, 
  hideErrors,
  isFieldArray,
  ...otherProps
}: FormControlledInputAreaProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  let fieldError = errors[formID];
  if (isFieldArray) {
    fieldError = getFieldArrayError(formID, errors);
  }

  return (
    <React.Fragment>
      <Controller
        defaultValue={defaultValue}
        control={control}
        name={formID}
        rules={rules}
        render={({ field }) => (
          <InputTextarea
            id={formID}
            placeholder={placeholder}
            disabled={disabled}
            className={`w-full blackText text-standard ${
              fieldError && 'p-invalid'
            }`}
            {...otherProps}
            {...field}
          />
        )}
      />
      {fieldError && !hideErrors && (
        <FormErrorMessage errorMessage={fieldError.message as string} />
      )}
    </React.Fragment>
  );
};

export default FormControlledInputArea;
